import React, { createContext, useContext } from "react";
import { useGuidedTour } from "../hooks/useGuidedTour";
import GuidedTour from "./GuidedTour";

// Holds the tour controls so the help panel can start a tour without having to
// thread callbacks through the app shell. Must be rendered inside the Router —
// the hook resolves the current page from the location.
const TourContext = createContext(null);

export const useTourControls = () => useContext(TourContext) || {};

export function TourProvider({ children }) {
  const tour = useGuidedTour();

  return (
    <TourContext.Provider value={tour}>
      {children}
      {tour.activeTour && (
        <GuidedTour
          key={tour.activeTour.id}
          tour={tour.activeTour}
          onFinish={tour.finishTour}
          onDisableAll={tour.disableAllTours}
        />
      )}
    </TourContext.Provider>
  );
}

export default TourProvider;
